// extracted by mini-css-extract-plugin
module.exports = {"sitewideContainer":"promotion-banner_sitewideContainer__Sj4Or","sitewideContent":"promotion-banner_sitewideContent__BVGyN","phoneLink":"promotion-banner_phoneLink__28uys"};